
import React from 'react';

const DashboardFooter: React.FC = () => {
  return (
    <footer className="py-8 px-6 border-t border-white/10">
      <div className="max-w-6xl mx-auto flex justify-center items-center">
        <div className="text-sm text-muted-foreground">
          © 2025 DeepCrawl by Guerrilla Buzz LTD. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
